import { Outlet } from "react-router-dom";

const ReactLayout = () => <Outlet />;

export default ReactLayout;
